import * as root from "~~/_core/store/root";

export const state = root.state;
export const mutations = root.mutations;
export const getters = root.getters;

// export const state = () => ({
//   ...root.state(),
//   configs: [],
//   configsLoaded: false,
// });

// export const mutations = {
//   ...root.mutations,
//   SET_CONFIGS(state, configs) {
//     state.configs = configs;
//     state.configsLoaded = true;
//   },
// };

// export const getters = {
//   ...root.getters,
//   getConfigs: (state) => state.configs,
//   isConfigsLoaded: (state) => state.configsLoaded,
// };

export const actions = {
  ...root.actions,

  // async fetchConfig({ commit, state }) {
  //   if (state.configsLoaded) return state.configs;

  //   try {
  //     const { data } = await this.$axios.get("/api/config/");
  //     commit("SET_CONFIGS", data.results || []);
  //     return data.results;
  //   } catch (error) {
  //     console.error("Error fetching configs:", error);
  //     return [];
  //   }
  // },

  async nuxtServerInit({ dispatch, state }, context) {
    // https://nuxtjs.org/guide/vuex-store/#the-nuxtserverinit-action
    // automatically refresh the access token on the initial request to the server, if possible
    // const { access_token, refresh_token } = state.auth;
    // const { $axios } = context;
    // TODO:
    // call /verify `access_token` to check expiry
    // If not expired, just keep doing
    // Otherwise call /refresh
    // Finally if expired refresh_token, then logout

    // NEED TO FEED DATA TO UPDATE STORE ON CLIENT SOON
    // https://stackoverflow.com/questions/43192154/vuex-store-gone-with-refresh
    // https://hashinteractive.com/blog/using-nuxtserverinit-in-vuex-to-fetch-component-data/
    // https://github.com/nuxt/nuxt/issues/1019

    // if (access_token && refresh_token) {
    //   try {
    //     // refresh the access token
    //     await dispatch('auth/refresh');
    //   } catch (e) {
    //     // catch any errors and automatically logout the user
    //     await dispatch('auth/logout');
    //   }
    // }

    // Fetch configs during app initialization
    // await dispatch("fetchConfig");

    // Initialize configs during server init
    await dispatch("config/fetchConfigs");

    await root.actions.nuxtServerInit(...arguments);

    // Project addition server init calls
    // ...
    // Your custom [nuxtServerInit] here
  },
};
